export default __webpack_public_path__ + "static/media/locationContact.9e9867fb.svg";